import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  FormControlLabel,
  Grid,
  Paper,
  makeStyles,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Select,
  MenuItem,
  TablePagination,
} from "@material-ui/core";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { setPeriodosPractica } from "../../../actions/autorizaciones/Autorizaciones";
import NumberFormat from "react-number-format";
import LetterX from "../UI/LetterX";
import { startAlerta } from "../../../actions/ui/alertas";
import { AUTORIZACIONES_BANDEJAS, AUTORIZACIONES_PRACTICAS_ESTADOS, AUTORIZACIONES_SOLICITUDES_ESTADOS } from "../../../utils/constants";

const useStyles = makeStyles({
  cell: {
    paddingLeft: '5%'
  },
});

export const ModalCantidadPracticasPeriodo = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  
  const { periodos, periodosOxigeno} = useSelector((state) =>
    state.autorizaciones.practicas.find(s => s.idCodNom === props.practica?.idCodNom));
  const tieneBandejaInternacionDomiciliaria = useSelector(state =>
    state.auth.bandejasAutorizacion.filter(s => s.idBandeja === AUTORIZACIONES_BANDEJAS.INTERNACION_DOMICILIARIA).length > 0);
  const { solicitudSeleccionada = {} } = useSelector(
    (state) => state.autorizaciones
  );
  const [items, setItems] = useState((props.esOxigeno && props.desdeAuditar) ? [...periodosOxigeno] : [...periodos]);

   var itemfilt =  items.sort((a, b) => a.periodo > b.periodo)
   console.log(itemfilt)
  const [cantidad, setCantidad] = useState('');
  const [periodo, setPeriodo] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(true);

  const dateNow = new Date();
  const yearNow = dateNow.getFullYear();
  const monthNow = dateNow.getMonth() + 1;
  const yearInternacion = props.fechaInicioInternacion.getFullYear();
  const monthInternacion = props.fechaInicioInternacion.getMonth() + 1;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    ValidatorForm.addValidationRule("periodDuplicated", (value) => {
      if (value) {
        if (items.filter(s => s.periodo === value).length === 0) {
          return true;
        }
        return false;
      }
      return false;
    });

    ValidatorForm.addValidationRule("periodValid", (value) => {
      if (value) {
        const year = parseInt(value.substring(0, 4));
        const month = parseInt(value.substring(4, 6));

        if (month > 0 && month <= 12) {
          if (year === yearNow)
            if (month <= monthNow)
              return true;
            else
              return false;
          return true;
        }
        return false;
      }
      return false;
    });

    ValidatorForm.addValidationRule("periodValidInternacion", (value) => {
      if (value) {
        const year = parseInt(value.substring(0, 4));
        const month = parseInt(value.substring(4, 6));

        if (year >= yearInternacion) {
          if (year === yearInternacion) {
            if (month >= monthInternacion)
              return true;
            else
              return false;
          }
          return true;
        }
        return false;
      }
      return false;
    });
  });

  const handleAgregarPeriodo = () => {
    const periodoTemp = {
      idCodNom: props.practica?.idCodNom,
      periodo: periodo,
      cant: Number(cantidad),
      idEstadoPeriodoPractica: AUTORIZACIONES_PRACTICAS_ESTADOS.GESTION
    };

    setItems([...items, periodoTemp]);
  }

  const handleChangePeriodoCantidad = (periodo, cantidad) => {
    setItems(
      items.map((item) => item.periodo === periodo
        ? {
          ...item,
          cant: Number(cantidad)
        }
        : item
      )
    )
  }

  const handleChangeEstadoPeriodo = (periodo, idEstado) => {
    setItems(
      items.map((item) => item.periodo === periodo
        ? {
          ...item,
          idEstadoPeriodoPractica: Number(idEstado)
        }
        : item
      )
    )
  }

  const handleDeletePeriodo = (periodo) => {
    setItems(
      items.filter(s => s.periodo !== periodo)
    )
  }

  const handleSubmitPeriodos = () => {
    if (items.filter(s => Number(s.cantidad === 0)).length > 0) {
      dispatch(startAlerta(`La Cantidad en todos los Periodos debe ser mayor a 0`, 'error', 'Error'));
    } else if (items.filter(s => s.idEstadoPeriodoPractica === AUTORIZACIONES_PRACTICAS_ESTADOS.PENDIENTE).length > 0 &&
      !tieneBandejaInternacionDomiciliaria && !props.permiteAgregarPracticaPeriodo) {
      dispatch(startAlerta(`Todos los Periodos deben tener un Estado`, 'error', 'Error'));
    }
    else {
      dispatch(setPeriodosPractica({ items, idCodNom: props.practica?.idCodNom }));
      props.onClose();
    }
  }
  return (
    <Dialog fullWidth maxWidth="md" open={props.open} >
      <DialogTitle>
        Práctica: &nbsp;
        <span style={{ fontStyle: "italic" }}>{`${props.practica?.practica?.codNom} - ${props.practica?.practica?.desNom}`}</span>
      </DialogTitle>
      <DialogContent >
        <ValidatorForm onSubmit={handleAgregarPeriodo}>
          <Grid item container justify="center" style={{ marginTop: -15, marginBottom: 25 }}>
            <Grid item xs={12} sm={5} md={3}>
              <TextValidator
                margin="normal"
                label="Periodo AAAAMM"
                name="periodo"
                value={periodo}
                autoComplete="off"
                disabled={!props.disabled}
                onChange={(e) => setPeriodo(e.target.value)}
                fullWidth
                style={{ paddingRight: "2.5rem", marginTop: 5 }}
                inputProps={{ maxLength: 6 }}
                validators={[
                  "required",
                  "isNumber",
                  "minNumber:99999",
                  "periodValidInternacion",
                  "periodDuplicated",
                ]}
                errorMessages={[
                  "El Periodo es requerido",
                  "Sólo números",
                  "Verifique el Periodo",
                  "Periodo anterior al de internación",
                  "El Periodo ya se encuentra cargado",
                ]}
              />
            </Grid>
            <Grid item xs={12} sm={5} md={3}>
              <TextValidator
                margin="normal"
                label="Cantidad"
                name="cantidad"
                value={cantidad}
                autoComplete="off"
                disabled={!props.disabled}
                onChange={(e) => setCantidad(e.target.value)}
                fullWidth
                style={{ paddingRight: "2.5rem", marginTop: 5 }}
                validators={[
                  "required",
                  "isNumber",
                  "minNumber:1",
                ]}
                errorMessages={[
                  "La Cantidad es requerida",
                  "Sólo números",
                  "La Cantidad mínima es 1",
                ]}
              />
            </Grid>
            <Grid item xs={12} sm={5} md={3} style={{ textAlign: 'center' }}>
              <Button
                type='submit'
                color="primary"
                variant="contained"
                style={{ marginTop: 15 }}
                disabled={!props.disabled}
              >
                Agregar Periodo
              </Button>
            </Grid>
          </Grid>
        </ValidatorForm>
        {Array.isArray(items) &&
          items?.length > 0 ? (
          <TableContainer component={Paper} style={{ overflowX: "auto" }}>
            <Table size={dense ? "small" : "medium"} >
              <TableHead>
                <TableRow>
                  {/* <TableCell>Codigo Nomenclador</TableCell> */}
                  <TableCell style={{ width: "10%" }}></TableCell>
                  <TableCell style={{ width: "15%" }} className={classes.cell}>Periodo</TableCell>
                  <TableCell style={{ width: "15%" }} className={classes.cell}>Cantidad</TableCell>
                  {tieneBandejaInternacionDomiciliaria &&
                    <TableCell style={{ width: "25%" }} className={classes.cell}>Estado Periodo</TableCell>
                  }
                  <TableCell style={{ width: "30%" }} className={classes.cell}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {items
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item) => {
                    return (
                      <TableRow key={item.periodo}>
                        {/* <TableCell>{item.practica?.codNom}</TableCell> */}
                        <TableCell className={classes.cell}>
                          {(props.disabled && item.idEstadoPeriodoPractica === AUTORIZACIONES_PRACTICAS_ESTADOS.GESTION) &&
                            <LetterX
                              deleteFunction={() => handleDeletePeriodo(item.periodo)}
                              styles={{
                                cursor: "pointer",
                                position: "relative",
                                top: "0.25rem",
                                marginRight: "0.5rem",
                              }}
                            />
                          }
                        </TableCell>
                        <TableCell className={classes.cell}>{item.periodo}</TableCell>
                        <TableCell className={classes.cell}>
                          <NumberFormat
                            style={{ maxWidth: 70 }}
                            onChange={(e) => handleChangePeriodoCantidad(item.periodo, e.target.value)}
                            disabled={props.disabled}
                            allowNegative={false}
                            value={item.cant}
                          />
                        </TableCell>
                        {tieneBandejaInternacionDomiciliaria &&
                          <TableCell className={classes.cell}>
                            <Select
                              style={{ width: "300px" }}
                              name="item.idEstadoPeriodoPractica"
                              value={item.idEstadoPeriodoPractica}
                              onChange={(e) => {
                                handleChangeEstadoPeriodo(item.periodo, e.target.value)
                              }}
                              disabled={solicitudSeleccionada.idEstadoSolicitud !==
                                AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE
                              }
                            >
                              {Array.isArray(Object.entries(AUTORIZACIONES_PRACTICAS_ESTADOS)) &&
                                Object.entries(AUTORIZACIONES_PRACTICAS_ESTADOS)?.length > 0 &&
                                Object.entries(AUTORIZACIONES_PRACTICAS_ESTADOS).filter(item => item[1] !==
                                  AUTORIZACIONES_PRACTICAS_ESTADOS.PENDIENTE && item[1] !==
                                  AUTORIZACIONES_PRACTICAS_ESTADOS.TERMINADA).map((estadoPractica) => (
                                    <MenuItem
                                      key={estadoPractica[1]}
                                      value={estadoPractica[1]}
                                    >
                                      {estadoPractica[0]}
                                    </MenuItem>
                                  ))}
                            </Select>
                          </TableCell>
                        }
                        <TableCell style={{ color: "red", fontWeight: "bold" }} className={classes.cell}>
                          {item.cant === 0 ? 'La cantidad debe ser mayor a 0' : ''}
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Typography style={{ fontStyle: "italic", fontSize: "1.1rem", textAlign: 'center', marginBottom: 15 }}>
            No hay periodos cargados
          </Typography>
        )}
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            {items?.length > 0 && (
              <Grid item xs={12}>
                <TablePagination
                  style={{ backgroundColor: "white" }}
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={items.length}
                  rowsPerPage={rowsPerPage}
                  labelRowsPerPage="Registros por página"
                  page={page}
                  onChangePage={handleChangePage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                />
              </Grid>
            )}
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent:items.length > 0 ? "space-between" : "right",
              margin: "1.5rem 0",
            }}
          >
            <FormControlLabel
              control={
                <Switch
                  checked={dense}
                  onChange={(e) => setDense(e.target.checked)}
                />
              }
              label="Tamaño compacto"
            />
            <div>
              <Button
                style={{ margin: "0 1rem", marginTop: 20 }}
                color="secondary"
                variant="contained"
                onClick={props.onClose}
              >
                {props.disabled ? 'Cerrar' : 'Cancelar'}
              </Button>
              <Button
                style={{ margin: "0 1rem", marginTop: 20 }}
                onClick={handleSubmitPeriodos}
                disabled={(props.disabled || !tieneBandejaInternacionDomiciliaria) ? false : true}
                color="primary"
                variant="contained"
              >
                Confirmar
              </Button>
            </div>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};
